
import React, { useEffect } from "react";
import { getImagePath } from "../../../SharedFiles/Helper/utils";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
  } from "@mui/material";
const QuantityModal = ({showModal, 
    closeModal, handleType, handleQtyChange,
    type, addToCart,quantityNos,selectedItem,quantity}) => {
      // useEffect(() => {
      //   const storedCartItems = (sessionStorage.getItem("cartItems"));
      //   if (storedCartItems) {
      //     setCartItems(JSON.parse(storedCartItems)); // Set cart items from sessionStorage if available
      //   }
      // }, []);
    return (
        <Dialog open={showModal}>
        <DialogTitle className="Modal-heading">Product Quantity</DialogTitle>
        <DialogContent className="salesDialog">
          <div>
            <div className="lineDiv lineDivItem">
              <span className="image-div">
                <img
                  src={getImagePath(selectedItem.deliverY_TYPE)}
                  alt={selectedItem.deliverY_TYPE}
                  className="group-image"
                />
              </span>
              <li className="groupSize align-items-center">
                <div className="itmlist">
                  <p className="itemcode item">{selectedItem.item_Name}</p>
                  <span className="itemname item">{selectedItem.height.toFixed(2)} mm</span>
                  <p className="itemcode item">{selectedItem.item_Code}</p>
                </div>
              </li>
            </div>

            <div className="quantityDiv">
              <p className="item quantityHeader">Enter Required Quantity</p>
              <p className="item noinbundle">({selectedItem.noinbundle} bars per Bundle)</p>
              <div className="quantityinput">
                <div>
                  <p className="item">
                    <select onChange={(e) => handleType(e.target.value)} value={type}>
                      <option value="bundle">Bundle</option>
                      <option value="quantity">Quantity</option>
                    </select>
                  </p>
                </div>
                <input
                  type="text"
                  inputMode="numeric" 
                  placeholder={type === "bundle" ? "Enter Bundle" : "Enter Quantity"}
                  onChange={(e) => handleQtyChange(e.target.value)}
                  value={quantity}
                />
              </div>
              <p className="item noinbundle">
                {type === "bundle"
                  ? `No of bars: ${quantityNos || 0}`
                  : `No of bundles: ${quantityNos || 0}`}
              </p>
            </div>
          </div>
        </DialogContent>
        <DialogActions className="custom-dialog-actions">
          <Button className="Modal-cancel" onClick={closeModal}>
            Cancel
          </Button>
          <Button className="Modal-submit" onClick={addToCart}>
            Add to Cart
          </Button>
        </DialogActions>
      </Dialog>
    );
  };
  export default QuantityModal;